import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { GroupTags } from '@/components/settings-route/tags'

export const Route = createFileRoute('/_auth/customers/tags')({
  component: CustomTagsWrapper,
})

export default function CustomTagsWrapper() {
  return (
    <Layout.Body>
      <GroupTags />
    </Layout.Body>
  )
}
